/**
 * Go Back Section Handler
 * Hides the section if there's no browser history to go back to
 */
class GoBackSection {
  constructor(section) {
    this.section = section;
    this.wrapper = section.querySelector('.goback-wrapper');
    this.hasCustomUrl = section.dataset.hasCustomUrl === 'true';

    this.init();
  }

  init() {
    // Only check history if using history.back() (no custom URL)
    if (!this.hasCustomUrl) {
      this.checkHistory();
    }
  }

  checkHistory() {
    // Check if there's actual browser history in the current tab/window
    // This is the most reliable way to know if history.back() will work
    // history.length > 1 means there are previous pages in this tab's history
    // history.length === 1 means this is the first/only page in this tab
    //   (new tab, direct access, refresh, etc.) - no history to go back to
    const hasHistoryInTab = window.history.length > 1;

    // If there's no history in the current tab, hide the section
    // This covers all cases: direct access, new tab, refresh, etc.
    if (!hasHistoryInTab) {
      this.hideSection();
    }
    // Note: We don't need to check referrer or sessionStorage because
    // history.length is the definitive indicator of whether history.back() will work
  }

  hideSection() {
    // Hide the entire section wrapper
    if (this.section) {
      this.section.style.display = 'none';
    }
  }
}

// Initialize all goback sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const gobackSections = document.querySelectorAll('[data-goback-section]');
  gobackSections.forEach((section) => {
    new GoBackSection(section);
  });
});

// Also handle dynamic content (e.g., theme editor)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const gobackSections = document.querySelectorAll('[data-goback-section]');
    gobackSections.forEach((section) => {
      new GoBackSection(section);
    });
  });
} else {
  const gobackSections = document.querySelectorAll('[data-goback-section]');
  gobackSections.forEach((section) => {
    new GoBackSection(section);
  });
}
